function markPropertyToRemove(propName) {
    return `_${propName}`
}

module.exports = {
    markPropertyToRemove
}
